module.exports = __webpack_public_path__ + "static/img/131_TO8_1687_og.8b68fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/131_TO8_1687_og.jpg
// module id = v63A
// module chunks = 0